import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '4rem 1rem' }}>
      <h1 style={{ fontSize: '3rem', margin: 0, color: '#fb923c' }}>404</h1>
      <p style={{ color: '#9ca3af', marginTop: '0.5rem' }}>That page doesn't exist.</p>
      <p style={{ marginTop: '1.5rem' }}>
        <Link to="/">← Back to home</Link>
      </p>
    </div>
  );
}
